export default __webpack_public_path__ + "static/media/ODD_BG-HOVER.df1ff63b.png";